import { useCallback, useEffect, useState } from "react";
import type {
  PortfolioConstructionType,
  Strategy,
} from "@repo/api";
export type RankingRuleType = "HIGHEST" | "LOWEST";
export const useRankingRule = (
  strategy: Strategy
): {
  rankingRule: RankingRuleType | undefined;
  setRankingRule: React.Dispatch<
    React.SetStateAction<RankingRuleType | undefined>
  >;
  convertRankingRuleToAscending: (
    constructionType: PortfolioConstructionType,
    rankingRule?: RankingRuleType
  ) => boolean;
  convertStrategyToRankingRule: () => RankingRuleType;
} => {
  const [rankingRule, setRankingRule] = useState<RankingRuleType | undefined>();

  useEffect(() => {
    const isAscending =
      typeof strategy.backtest.ascending === "boolean"
        ? strategy.backtest.ascending
        : true;
    const constructionType =
      strategy.backtest.portfolioConstruction || "LongShort";

    if (isAscending) {
      setRankingRule(constructionType !== "ShortOnly" ? "LOWEST" : "HIGHEST");
    } else {
      setRankingRule(constructionType === "ShortOnly" ? "LOWEST" : "HIGHEST");
    }
  }, [strategy]);

  const convertRankingRuleToAscending = useCallback(
    (
      constructionType: PortfolioConstructionType,
      rankingRule?: RankingRuleType
    ) => {
      if (rankingRule === "LOWEST") {
        return constructionType !== "ShortOnly";
      } else {
        return constructionType === "ShortOnly";
      }
    },
    []
  );

  const convertStrategyToRankingRule = useCallback(() => {
    let rankingRule = "HIGHEST" as RankingRuleType;
    if (strategy.backtest.ascending) {
      rankingRule =
        strategy.backtest.portfolioConstruction === "ShortOnly"
          ? "HIGHEST"
          : "LOWEST";
    } else {
      rankingRule =
        strategy.backtest.portfolioConstruction === "ShortOnly"
          ? "LOWEST"
          : "HIGHEST";
    }

    return rankingRule;
  }, [strategy]);

  return {
    rankingRule,
    setRankingRule,
    convertRankingRuleToAscending,
    convertStrategyToRankingRule,
  };
};
